// const [response, error] = await awaitHandler(someService.getData());
// const [response] = await awaitHandler(someService.getData());
// const [, error] = await awaitHandler(someService.getData());

export const awaitHandler = async <T = any, E = any>(
  promise: Promise<T>
): Promise<[T | undefined, E | undefined]> => {
  try {
    const data = await promise;
    return [data, undefined];
  } catch (error) {
    return [undefined, error as E];
  }
};
